<div class="background-container">
  <mat-card class="main-card">
    <div class="row d-flex justify-content-end">
      <div class="col-md-2 col-12 ">
        <a href="#" mat-button color="error" style="margin-top: 0.7rem; text-transform: uppercase;" routerLink="/auth">
          <mat-icon aria-hidden="false" fontIcon="logout"></mat-icon>
          Sair
        </a>
      </div>
    </div>
    <div class="row filter-container">
      <div class="col-md-4 col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data Início</mat-label>
          <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="dataInicioCorte">
          <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicio></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-4 col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data Fim</mat-label>
          <input matInput [matDatepicker]="pickerFim" [(ngModel)]="dataFimCorte">
          <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
          <mat-datepicker #pickerFim></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="row d-flex justify-content-end  p-4">
      <div class="col-md-3 col-12 ">
        <button mat-raised-button color="primary" class="w-100" (click)="filtrarRegistrosPendentes(true)">Filtrar pendentes</button>
      </div>
      <div class="col-md-3 col-12 ">
        <button mat-raised-button color="primary" class="w-100" (click)="filtrarRegistrosPendentes(false)">Filtrar todos</button>
      </div>
      <div class="col-md-3 col-12">
        <button mat-raised-button color="primary" class="w-100" (click)="visualizarRegistros(false)">Baixar</button>
      </div>
      <div class="col-md-3 col-12">
        <button mat-raised-button color="primary" class="w-100" (click)="visualizarRegistros(true)">Enviado para a seguradora</button>
      </div>
    </div>


    <mat-card class="table-container">
      <mat-card-title>Registros</mat-card-title>
      <div class="table-responsive" style="max-height: 800px; overflow-y: auto;">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100" *ngIf="dataSource" multiTemplateDataRows>
          <ng-container matColumnDef="linha">
            <th mat-header-cell *matHeaderCellDef> linha </th>
            <td mat-cell *matCellDef="let element"> {{ dataSource.data.indexOf(element) + 1 }} </td>
          </ng-container>
          <ng-container matColumnDef="matricula">
            <th mat-header-cell *matHeaderCellDef> Matrícula </th>
            <td mat-cell *matCellDef="let element"> {{ element.matricula || 'não informado' }} </td>
          </ng-container>

          <ng-container matColumnDef="nomeSegurado">
            <th mat-header-cell *matHeaderCellDef> Nome Segurado </th>
            <td mat-cell *matCellDef="let element"> {{ element.nomeSegurado || 'não informado' }} </td>
          </ng-container>

          <ng-container matColumnDef="cpf">
            <th mat-header-cell *matHeaderCellDef> CPF </th>
            <td mat-cell *matCellDef="let element"> {{ element.cpf || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{ element.email || 'não informado' }} </td>
          </ng-container>

          <ng-container matColumnDef="dataAdesao">
            <th mat-header-cell *matHeaderCellDef> Data Adesão </th>
            <td mat-cell *matCellDef="let element"> {{ maskDate(element.dataAdesao) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="dataInicioDoContratoDeFinanciamento">
            <th mat-header-cell *matHeaderCellDef> Início Contrato </th>
            <td mat-cell *matCellDef="let element"> {{ maskDate(element.dataInicioDoContratoDeFinanciamento) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="dataTerminoDoContratoDeFinanciamento">
            <th mat-header-cell *matHeaderCellDef> Término Contrato </th>
            <td mat-cell *matCellDef="let element"> {{ maskDate(element.dataTerminoDoContratoDeFinanciamento) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="prazoFinanciamento">
            <th mat-header-cell *matHeaderCellDef> Prazo Financiamento </th>
            <td mat-cell *matCellDef="let element"> {{ element.prazoFinanciamento || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="capitalSegurado">
            <th mat-header-cell *matHeaderCellDef> Capital Segurado </th>
            <td mat-cell *matCellDef="let element"> {{ maskValores(element.capitalSegurado) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="valorDaParcelaMensalDoFinanciamento">
            <th mat-header-cell *matHeaderCellDef> Parcela Mensal </th>
            <td mat-cell *matCellDef="let element"> {{ maskValores(element.valorDaParcelaMensalDoFinanciamento) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="premioUnicoDoSeguro">
            <th mat-header-cell *matHeaderCellDef> Prêmio Único </th>
            <td mat-cell *matCellDef="let element"> {{ maskValores(element.premioUnicoDoSeguro) || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element"> {{ element.status || 'não informado'}} </td>
          </ng-container>

          <ng-container matColumnDef="baixar">
            <th mat-header-cell *matHeaderCellDef> Baixar </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="baixarProposta(element.matricula)">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-card>

    <mat-paginator [length]="totalRecords" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100, 500]" showFirstLastButtons (page)="onPageChange($event)"></mat-paginator>
  </mat-card>
</div>

<div class="loader" *ngIf="showLoader">
  <div class="content-loader">
    <mat-spinner></mat-spinner>
  </div>
</div>

